import axios from "axios";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default {
  methods: {
    async reportHasilAuditPerTemuan(val, opsi) {
      const reportData = await this.loadDataReportPerTemuan(val, opsi);

      const docDef = {
        pageSize: "A4",
        pageOrientation: "landscape",
        pageMargins: [17, 85, 17, 30],
        header: [
          {
            text: localStorage.namaUnit,
            fontSize: 14,
            bold: true,
            margin: [17, 20, 0, 3],
          },
          {
            text: "Rekapitulasi Temuan dan Tindaklanjut Berdasarkan Kode Group Temuan",
            fontSize: 13,
            margin: [17, 0, 0, 0],
          },
          {
            text:
              "Periode Pelaporan " + opsi.dateMulai.toLocaleDateString("id"),
            fontSize: 8,
            style: "headerPeriod",
            margin: [0, 0, 17, 3],
          },
          {
            text: "sd. " + opsi.dateSelesai.toLocaleDateString("id"),
            fontSize: 8,
            margin: [0, 0, 17, 7],
            style: "headerPeriod",
          },
        ],

        footer: function (currentPage, pageCount) {
          return {
            columns: [
              {
                text: "Tanggal Cetak : " + new Date().toLocaleString("id"),
                margin: [17, 0, 0, 0],
                fontSize: 7,
              },
              {
                text:
                  "halaman ke " + currentPage.toString() + " dari " + pageCount,
                alignment: "right",
                margin: [0, 0, 40, 0],
                fontSize: 7,
              },
            ],
          };
        },

        content: [
          {
            style: "tableExample",
            color: "#444",
            table: {
              widths: [
                "auto",
                "auto",
                "auto",
                "auto",
                "auto",
                "auto",
                "auto",
                "auto",
                "auto",
                "auto",
                "auto",
              ],
              // headerRows: 2,
              // keepWithHeaderRows: 1,
              body: [
                [
                  {
                    text: "No",
                    style: "tableHeader",
                    bold: true,
                    alignment: "center",
                  },
                  {
                    text: "Sub Kelompok Temuan",
                    style: "tableHeader",
                    bold: true,
                    alignment: "center",
                  },
                  {
                    text: "Kode",
                    style: "tableHeader",
                    bold: true,
                    alignment: "center",
                  },
                  {
                    text: "Jumlah Kejadian",
                    style: "tableHeader",
                    bold: true,
                    alignment: "center",
                  },
                  {
                    text: "%",
                    style: "tableHeader",
                    bold: true,
                    alignment: "center",
                  },
                  {
                    text: "Nilai Temuan",
                    style: "tableHeader",
                    bold: true,
                    alignment: "center",
                  },
                  {
                    text: "Jumlah TL",
                    style: "tableHeader",
                    bold: true,
                    alignment: "center",
                  },

                  {
                    text: "Nilai TL",
                    style: "tableHeader",
                    bold: true,
                    alignment: "center",
                  },
                  {
                    text: "Saldo TL",
                    style: "tableHeader",
                    bold: true,
                    alignment: "center",
                  },
                  {
                    text: "%",
                    style: "tableHeader",
                    bold: true,
                    alignment: "center",
                  },
                  {
                    text: "Saldo Nilai TL",
                    style: "tableHeader",
                    bold: true,
                    alignment: "center",
                  },
                ],
                [
                  { text: 1, style: "tableContent" },
                  {
                    text: "Kerugian negara/daerah atau kerugian negara/daerah yang terjadi pada perusahaan milik negara/daerah",
                    style: "tableContent",
                  },
                  { text: 101, style: "tableContent" },
                  {
                    text: reportData?.jumlahKejadianTemuan101,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseJumlahKejadianTemuan101,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.jumlahNilaiTemuan101,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.jumlahTlTemuan101,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.jumlahNilaiTlTemuan101,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.saldoKejadianTemuan101,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseSaldoKejadianTemuan101,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.saldoNilaiTemuan101,
                    style: "tableContent",
                  },
                ],
                [
                  { text: 2, style: "tableContent" },
                  {
                    text: "Potensi kerugian negara/daerah atau kerugian negara/daerah yang terjadi pada perusahaan milik negara",
                    style: "tableContent",
                  },
                  { text: 102, style: "tableContent" },
                  {
                    text: reportData?.jumlahKejadianTemuan102,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseJumlahKejadianTemuan102,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.jumlahNilaiTemuan102,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.jumlahTlTemuan102,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.jumlahNilaiTlTemuan102,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.saldoKejadianTemuan102,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseSaldoKejadianTemuan102,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.saldoNilaiTemuan102,
                    style: "tableContent",
                  },
                ],
                [
                  { text: 3, style: "tableContent" },
                  {
                    text: "Kekurangan penerimaan negara/daerah atau perusahaan milik negara/daerah",
                    style: "tableContent",
                  },
                  { text: 103, style: "tableContent" },
                  {
                    text: reportData?.jumlahKejadianTemuan103,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseJumlahKejadianTemuan103,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.jumlahNilaiTemuan103,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.jumlahTlTemuan103,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.jumlahNilaiTlTemuan103,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.saldoKejadianTemuan103,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseSaldoKejadianTemuan103,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.saldoNilaiTemuan103,
                    style: "tableContent",
                  },
                ],
                [
                  { text: 4, style: "tableContent" },
                  { text: "Administrasi", style: "tableContent" },
                  { text: 104, style: "tableContent" },
                  {
                    text: reportData?.jumlahKejadianTemuan104,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseJumlahKejadianTemuan104,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.jumlahNilaiTemuan104,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.jumlahTlTemuan104,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.jumlahNilaiTlTemuan104,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.saldoKejadianTemuan104,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseSaldoKejadianTemuan104,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.saldoNilaiTemuan104,
                    style: "tableContent",
                  },
                ],
                [
                  { text: 5, style: "tableContent" },
                  { text: "Indikasi tindak pidana", style: "tableContent" },
                  { text: 105, style: "tableContent" },
                  {
                    text: reportData?.jumlahKejadianTemuan105,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseJumlahKejadianTemuan105,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                  {
                    text: reportData?.jumlahTlTemuan105,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                  {
                    text: reportData?.saldoKejadianTemuan105,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseSaldoKejadianTemuan105,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                ],
                [
                  {
                    text: "Subtotal Kejadian",
                    style: "tableContent",
                    colSpan: 3,
                    bold: true,
                  },
                  {},
                  {},
                  {
                    text: reportData?.subTotalJumlahKejadianTemuan01,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseSubTotalJumlahKejadianTemuan01,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.subTotalJumlahNilaiTemuan01,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.subTotalKejadianTindakLanjutTemuan01,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.subTotalNilaiTindakLanjutTemuan01,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.subTotalSaldoKejadianTemuan01,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseSubTotalSaldoKejadianTemuan01,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.subTotalSaldoNilaiTemuan01,
                    style: "tableContent",
                  },
                ],
                [
                  { text: 1, style: "tableContent" },
                  {
                    text: "Kelemahan sistem pengendalian akuntansi dan pelaporan",
                    style: "tableContent",
                  },
                  { text: 201, style: "tableContent" },
                  {
                    text: reportData?.jumlahKejadianTemuan201,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseJumlahKejadianTemuan201,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                  {
                    text: reportData?.jumlahTlTemuan201,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                  {
                    text: reportData?.saldoKejadianTemuan201,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseSaldoKejadianTemuan201,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                ],
                [
                  { text: 2, style: "tableContent" },
                  {
                    text: "Kelemahan sistem pengendalian pelaksanaan anggaran pendapatan dan belanja",
                    style: "tableContent",
                  },
                  { text: 202, style: "tableContent" },
                  {
                    text: reportData?.jumlahKejadianTemuan202,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseJumlahKejadianTemuan202,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                  {
                    text: reportData?.jumlahTlTemuan202,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                  {
                    text: reportData?.saldoKejadianTemuan202,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseSaldoKejadianTemuan202,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                ],
                [
                  { text: 3, style: "tableContent" },
                  {
                    text: "Kelemahan struktur pengendalian intern",
                    style: "tableContent",
                  },
                  { text: 203, style: "tableContent" },
                  {
                    text: reportData?.jumlahKejadianTemuan203,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseJumlahKejadianTemuan203,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                  {
                    text: reportData?.jumlahTlTemuan203,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                  {
                    text: reportData?.saldoKejadianTemuan203,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseSaldoKejadianTemuan203,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                ],
                [
                  {
                    text: "Subtotal Kejadian",
                    style: "tableContent",
                    colSpan: 3,
                    bold: true,
                  },
                  {},
                  {},
                  {
                    text: reportData?.subTotalJumlahKejadianTemuan02,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseSubTotalJumlahKejadianTemuan02,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                  {
                    text: reportData?.subTotalKejadianTindakLanjutTemuan02,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                  {
                    text: reportData?.subTotalSaldoKejadianTemuan02,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseSubTotalSaldoKejadianTemuan02,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                ],

                [
                  { text: 1, style: "tableContent" },
                  {
                    text: "Ketidakhematan/pemborosan/ketidakekonomisan",
                    style: "tableContent",
                  },
                  { text: 301, style: "tableContent" },
                  {
                    text: reportData?.jumlahKejadianTemuan301,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseJumlahKejadianTemuan301,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                  {
                    text: reportData?.jumlahTlTemuan301,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                  {
                    text: reportData?.saldoKejadianTemuan301,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseSaldoKejadianTemuan301,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                ],
                [
                  { text: 2, style: "tableContent" },
                  { text: "Ketidakefisienan", style: "tableContent" },
                  { text: 302, style: "tableContent" },
                  {
                    text: reportData?.jumlahKejadianTemuan302,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseJumlahKejadianTemuan302,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                  {
                    text: reportData?.jumlahTlTemuan302,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                  {
                    text: reportData?.saldoKejadianTemuan302,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseSaldoKejadianTemuan302,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                ],
                [
                  { text: 3, style: "tableContent" },
                  { text: "Ketidakefektifan", style: "tableContent" },
                  { text: 303, style: "tableContent" },
                  {
                    text: reportData?.jumlahKejadianTemuan303,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseJumlahKejadianTemuan303,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                  {
                    text: reportData?.jumlahTlTemuan303,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                  {
                    text: reportData?.saldoKejadianTemuan303,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseSaldoKejadianTemuan303,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                ],
                [
                  {
                    text: "Subtotal Kejadian",
                    style: "tableContent",
                    colSpan: 3,
                    bold: true,
                  },
                  {},
                  {},
                  {
                    text: reportData?.subTotalJumlahKejadianTemuan03,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseSubTotalJumlahKejadianTemuan03,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                  {
                    text: reportData?.subTotalKejadianTindakLanjutTemuan03,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                  {
                    text: reportData?.subTotalSaldoKejadianTemuan03,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseSubTotalSaldoKejadianTemuan03,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                ],
                [
                  {
                    text: "Jumlah Kejadian",
                    style: "tableContent",
                    colSpan: 3,
                    bold: true,
                  },
                  {},
                  {},
                  {
                    text: reportData?.jumlahKejadianTemuan,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseTotalKejadianTemuan,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.jumlahNilaiKejadianTemuan,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.jumlahKejadianTindakLanjutTemuan,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.jumlahNilaiTindakLanjutTemuan,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.saldoKejadianTemuan,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseSaldoKejadianTemuan,
                    style: "tableContent",
                  },
                  { text: reportData?.saldoNilaiTemuan, style: "tableContent" },
                ],
              ],
            },

            layout: {
              // hLineWidth: function (i, node) {
              //   return i === 0 || i === 2 ? 1.5 : 0.5;
              // },
              // vLineWidth: function (i, node) {
              //   return 0;
              // },
              // fillColor: function (rowIndex, node, columnIndex) {
              //   return rowIndex % 3 === 0 && rowIndex > 1 ? "#eeeeee" : null;
              // },
              // hLineColor: function (i, node) {
              //   return i === 0 || i === node.table.body.length
              //     ? 'black'
              //     : 'gray';
              // },
              // vLineColor: function (i, node) {
              //   return i === 0 || i === node.table.widths.length
              //     ? 'black'
              //     : 'gray';
              // },
              // hLineStyle: function (i, node) { return {dash: { length: 10, space: 4 }}; },
              // vLineStyle: function (i, node) { return {dash: { length: 10, space: 4 }}; },
              // paddingLeft: function (i, node) {
              //   return 20;
              // },
              // paddingRight: function(i, node) { return 4; },
              paddingTop: function (i, node) {
                return 4;
              },
              paddingBottom: function (i, node) {
                return 4;
              },
              // fillColor: function (rowIndex, node, columnIndex) { return null; }
            },
          },
        ],
        styles: {
          headerPeriod: {
            alignment: "right",
          },
          tableHeader: {
            alignment: "center",
            fontSize: 10,
          },
          tableContent: {
            fontSize: 10,
          },
          tableSubHeader: {
            alignment: "left",
            fontSize: 8,
            bold: true,
          },
        },
      };

      pdfMake.createPdf(docDef).open();
    },

    async loadDataReportPerTemuan(val, opsi) {
      try {
        const response = await axios({
          method: "GET",
          baseURL: this.$apiAddress,
          url: val.endpoint,
          params: {
            token: localStorage.getItem("api_token"),
            fromDate: opsi.dateMulai.toLocaleDateString("fr-CA"),
            toDate: opsi.dateSelesai.toLocaleDateString("fr-CA"),
          },
        });

        if (response.status == 200) {
          const responseData = await response.data;
          // console.log("--> Response DATA : ", responseData);
          return responseData;
        }
      } catch (error) {
        console.log(error.message);
      }
    },
  },
};
